/**
 * en-GB messages added by Phase 3 task S28 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s28EnGB = {
    'email.compliance.expiry_reminder.subject': '{tenant}: {document} runs out in {daysLeft} days',
    'email.compliance.expiry_reminder.body': 'Hello {name}, the {document} we hold for you runs out on {expiryDate} ({daysLeft} days from now). Please send an up to date copy to reception or upload it in the app before then, so you can keep signing in without delay.',
    'compliance.annotation.warning': 'Compliance warning',
    'compliance.error.state': 'This document has already been reviewed.',
    'compliance.error.type': 'Choose an active document type.',
    'compliance.error.duplicate_type': 'Each document type can be listed only once.',
    'compliance.error.file_required': 'This document type needs a file.',
    'compliance.error.expiry_required': 'This document type needs an expiry date.',
    'compliance.error.issue_required': 'This document type needs an issue date.',
    'compliance.error.dates': 'The expiry date cannot be before the issue date.',
    'compliance.error.upload': 'That upload could not be used. Upload the file again.',
    'compliance.error.too_many_uploads': 'Too many files are waiting to be attached. Attach or wait for them to clear, then try again.',
    'compliance.error.self_upload_off': 'Uploading your own documents is switched off for your group.',
    'compliance.col.name': 'Name',
    'compliance.col.group': 'Group',
    'compliance.col.document': 'Document',
    'compliance.col.state': 'Status',
    'compliance.col.expiry': 'Expiry date',
    'compliance.state.valid': 'Valid',
    'compliance.state.expiring': 'Expiring soon',
    'compliance.state.expired': 'Expired',
    'compliance.state.missing': 'Missing',
    'compliance.state.pending_review': 'Waiting for review',
    'compliance.state.rejected': 'Rejected',
    'compliance.report.sheet': 'Compliance',
};
//# sourceMappingURL=s28.js.map